/*
 * @Date: 2020-08-28 15:57:18
 * @Author: MX
 * @LastEditTime: 2022-12-19 18:17:47
 * @Description: 校验规则
 */
import { lang } from '@/utils/filters'
export const RULES = {
  account: { required: true, message: lang('请输入账号'), trigger: ['blur', 'change'] }, //账号
  password: { required: true, message: lang('请输入密码'), trigger: ['blur', 'change'] }, //密码
  phone: { required: true, message: lang('请输入手机号'), trigger: ['blur', 'change'] },  //手机号
  checkPassword: { validator: checkPassword, trigger: ['blur', 'change'] }, // 校验密码
  passwordNew:{validator: passwordNew, trigger: ['blur', 'change'] },
  checkPhone: { min: 0, max: 11, validator: checkPhone, trigger: ['blur', 'change'] }, // 校验手机号
  captcha: { required: true, message: lang('请输入图形验证码'), trigger: ['blur', 'change'] },//请输入验证码
  phoneCode: { required: true, message: lang('请输入邮箱验证码'), trigger: ['blur', 'change'] },
  checkIdCard: { validator: checkIdCard, trigger: ['blur', 'change'] },//校验身份证
  url:{validator:urlValidation,trigger: ['blur', 'change']},//校验url
  email: { validator: email, trigger: ['blur', 'change'] }, // 邮箱
  messageNumber: { validator: messageNumber, trigger: ['blur', 'change'] }, // 短信数量
  number:{validator: number, trigger: ['blur', 'change']},
  noBlankSpace: { validator: noBlankSpace, trigger: ['blur', 'change'] },
  chMobile: { validator: chMobile, trigger: ['blur', 'change'] }, // 手机号码校验
  required: { required: true, message: lang('请输入'), trigger: ['blur', 'change'] }
}

//验证身份证
export function checkIdCard (rule, value, callback) {
  if (value && !(VALIDATION.checkIdCard.value.test(value) && (/\d/).test(value))) {
    callback(new Error(VALIDATION.checkIdCard.label))
  } else {
    callback()
  }
}


// 验证密码
export function checkPassword (rule, value, callback) {
  if (value && !(VALIDATION.checkPassword.value.test(value) && (/\d/).test(value))) {
    callback(new Error(VALIDATION.checkPassword.label))
  } else {
    callback()
  }
}
// 校验手机号不能超过11位，且为数字
export function checkPhone (rule, value, callback) {
  if (value && !VALIDATION.phoneNumber.value.test(value)) {
    callback(new Error(VALIDATION.phoneNumber.label))
  } else {
    callback()
  }
}
// 验证密码 新
export function passwordNew (rule, value, callback) {
  if (value && !VALIDATION.passwordNew.value.test(value)) {
    callback(new Error(VALIDATION.passwordNew.label))
  } else {
    callback()
  }
}
// url校验 新
export function urlValidation (rule, value, callback) {
  if (value && !VALIDATION.url.value.test(value)) {
    callback(new Error(VALIDATION.url.label))
  } else {
    callback()
  }
}
// 可空 email 邮箱格式校验
export function email(rule, value, callback) {
  if (value && !VALIDATION.email.value.test(value)) {
    callback(new Error(VALIDATION.email.label))
  } else {
    callback()
  }
}
// 短信数量校验
export function messageNumber(rule, value, callback) {
  if (value && !VALIDATION.messageNumber.value.test(value) || value && Number(value) % 1000 !== 0) {
    callback(new Error(VALIDATION.messageNumber.label))
  } else {
    callback()
  }
}
// 不能有空格
export function noBlankSpace(rule, value, callback) {
  if (!VALIDATION.noBlankSpace.value.test(value)) {
    callback(new Error(VALIDATION.noBlankSpace.label))
  } else {
    callback()
  }
}
export function chMobile(rule, value, callback) {
  if (value) {
    const data = value.split(",")
    let state = false
    for (let i = 0; i < data.length; i++) {
      if (data[i] && !VALIDATION.chMobile.value.test(data[i])) {
        state = true
      }
      if(!data[i]){
        callback(new Error(VALIDATION.chMobile.label))
      }
    }
    if (data.length > 5) {
      callback(new Error(lang("最多5个手机号")))
    }else
    if (state) {
      callback(new Error(VALIDATION.chMobile.label))
    }else{
      callback()
    }
  } else {
    callback()
  }
}
// 数字校验
export function number(rule, value, callback) {
  if (value && !VALIDATION.number.value.test(value)) {
    callback(new Error(VALIDATION.number.label))
  } else {
    callback()
  }
}
/* eslint-disable  */
export const VALIDATION = {
  'phoneNumber': {
    'value': /^1[3|4|5|6|7|8|9][0-9]\d{8,8}$/,
    'label': lang('输入的手机号码格式不正确'),
  },
  'checkPassword': {
    'value': /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\\W_!@#$%^&*`.+=~()-+=]{6,18}$/,
    'label': lang('请输入6-18位之间，大写字母、小写字母、数字和特殊字符'),
  },
  "checkIdCard": {
    'value': /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    'label': lang('请输入正确的居民身份证'),
  },
  // 密码校验 新
  'passwordNew': {
    label: lang('大写字母、小写字母、数字和特殊字符4选3,长度8-18'),
    value: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`.+=~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`.+=~()-+=]+$)(?![0-9\\W_!@#$%^&*`.+=~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`.+=~()-+=]{8,18}$/
    // value: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`.+=~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`.+=~()-+=]+$)(?![0-9\\W_!@#$%^&*`.+=~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`.+=~()-+=]{8,30}$/
  },
  url: {
    label: lang("请输入以http/https为开头的url"),
    value: /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?$/i,
    //   value:/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/,
  },
  email: {
    label: lang('请输入正确的邮箱账号'),
    value: /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i
  },
  messageNumber: {
    label: lang('请输入1000倍数的数字'),
    value: /^[1-9][0-9]*$/i
  },
  number: {
    label: lang('请输入数字'),
    value: /^[0-9]*$/
  },
  noBlankSpace: {
    value: /^\S*$/,
    label: lang('请勿输入空格')
  },
  chMobile: {
    value: /^1[3|4|5|7|8][0-9]\d{8,8}$/,
    label: lang('输入的手机号码格式不正确')
  },
}
